import { z } from 'zod/v3';

export const tenantPickerValueSchema = z.string();

export const tenantPickerUiOptionsSchema = z.object({});

export type TenantPickerValue = z.infer<typeof tenantPickerValueSchema>;
export type TenantPickerUiOptions = z.infer<
  typeof tenantPickerUiOptionsSchema
>;
